import { useQuery } from '@tanstack/react-query';
import { publicSeoApi, type PublicSeoPageType } from '../services/publicSeo.api';

const SEO_QUERY_STALE_TIME = 1000 * 60 * 10;

export function usePublicSeoPage(pageType: PublicSeoPageType | undefined, signal?: AbortSignal) {
  return useQuery({
    queryKey: ['public-seo', 'page', pageType],
    queryFn: () => publicSeoApi.getPage(pageType!, signal),
    enabled: Boolean(pageType),
    staleTime: SEO_QUERY_STALE_TIME,
    refetchOnWindowFocus: false,
    retry: false,
  });
}

export function usePublicSeoEntity(
  entityType: 'package' | 'destination' | 'article',
  slug: string | undefined,
  signal?: AbortSignal
) {
  return useQuery({
    queryKey: ['public-seo', entityType, slug],
    queryFn: () => {
      if (!slug) return Promise.resolve(null);
      if (entityType === 'package') return publicSeoApi.getPackage(slug, signal);
      if (entityType === 'destination') return publicSeoApi.getDestination(slug, signal);
      return publicSeoApi.getArticle(slug, signal);
    },
    enabled: Boolean(slug),
    staleTime: SEO_QUERY_STALE_TIME,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
